<template>
  <div>
    <div class="card buildingCard" v-if="buildingProcessedId">
      <div class="card-body buildingCard-body"  v-if="!showBuildingInformation">
        <h5 class="card-title buildingCard-title" v-if="pageTitle">
                 <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          {{pageTitle}}
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title='The master list of all emergency lights in the site'
              ></i>
            </sup>
          </ToolTip>
        </h5>
        <div class="text-center" v-if="!noDevicesFound">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="text-center" v-else>
          <p>No Devices Found</p>
        </div>
      </div>
      <div class="card-body buildingCard-body" v-else-if="testStatusRawMapping !== undefined">
        <h5 class="card-title buildingCard-title" v-if="pageTitle">
                <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          {{pageTitle}}
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title='The master list of all emergency lights in the site'
              ></i>
            </sup>
          </ToolTip>
        </h5>
        <p class="alert alert-warning" v-if="!hadFullTest">
          <strong>Please note:</strong> Devices may show failure status during the installation period. A proper full scheduled test will clear the failure status
        </p>
        <div class="d-lg-none buildingCard-mobile-menu">
          <div class="buildingCard-mobile-menu-item">
                    <span class="btn buildingCard-mobile-menu-item-plain-text">
                        {{sortedDevices.length}} Results
                    </span>
          </div>
          <div class="buildingCard-mobile-menu-item buildingCard-mobile-menu-item-dropdown" v-if="showBuildingInformation">
            <div class="dropdown float-right">
              <button class="btn btn-secondary dropdown-toggle buildingCard-mobile-dropdown-filter" type="button" id="dropdownFilter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Filter
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownFilter">
                <form novalidate v-on:submit.prevent>
                  <h6 class="dropdown-header">Filter</h6>
                  <div class="dropdown-item">
                    <select class="custom-select buildingCard-body-tablet-block" v-model="currentFilters.level" v-on:change="client.currentPage = 1;" multiple>
                      <option v-bind:value="undefined" selected>Reset Level Filter</option>
                      <option v-for="level in levels" v-bind:value="JSON.stringify([level])">
                        Level {{level}}
                      </option>
                    </select>
                  </div>
                  <div class="dropdown-item">
                    <select class="custom-select buildingCard-body-tablet-block" v-model="currentFilters.status" multiple>
                      <option v-bind:value="undefined" selected>Reset Device Status Filter</option>
                      <template  v-for="(data, index) in deviceStatusList">
                        <optgroup v-if="Object.keys(data[1]).length" v-bind:label="`-- ${data[0]} --`">
                          <option v-for="(subData, subIndex) in data[1]" v-bind:value="JSON.stringify([index, subIndex])">&nbsp;&nbsp;&nbsp;&nbsp;{{subData[0]}}</option>
                        </optgroup>
                        <option v-else v-bind:value="JSON.stringify([index])">
                          {{data[0]}}
                        </option>

                      </template>
                    </select>
                  </div>
                  <div class="dropdown-item">
                    <select class="custom-select buildingCard-body-tablet-block" v-model="currentFilters.test" v-on:change="client.currentPage = 1;" multiple>
                      <option v-bind:value="undefined" selected>Reset Test Result Filter</option>
                      <option v-for="(data, index) in testStatusList" v-bind:value="JSON.stringify([index])">
                        {{data[0]}}
                      </option>
                    </select>
                  </div>
                  <div class="dropdown-item customSearchFilter">
                    <div class="form-group hasSearch">
                      <input type="text" class="form-control hasSearch-formControl" v-model="currentFilters.search" v-on:keydown="client.currentPage = 1" placeholder="Search">
                      <i class="fa fa-search hasSearch-icon"></i>
                    </div>
                  </div>

                  <div class="dropdown-divider"></div>
                  <h6 class="dropdown-header">Sort by</h6>
                  <div class="dropdown-item">
                    <select class="custom-select buildingCard-body-tablet-block" v-model="currentSort">
                      <option v-bind:value="{field: 'fitting_number', sort: 'asc'}">
                        Fitting Number: Low to High
                      </option>
                      <option v-bind:value="{field: 'fitting_number', sort: 'desc'}">
                        Fitting Number: High to Low
                      </option>
                      <option v-bind:value="{field: 'fitting_type.name', sort: 'asc'}">
                        Fitting Type: A to Z
                      </option>
                      <option v-bind:value="{field: 'fitting_type.name', sort: 'desc'}">
                        Fitting Type: Z to A
                      </option>
                      <option v-bind:value="{field: 'level', sort: 'asc'}">
                        Level Number: Low to High
                      </option>
                      <option v-bind:value="{field: 'level', sort: 'desc'}">
                        Level Number: High to Low
                      </option>
                      <option v-bind:value="{field: 'location', sort: 'asc'}">
                        Location: A to Z
                      </option>
                      <option v-bind:value="{field: 'location', sort: 'desc'}">
                        Location: Z to A
                      </option>
                      <option v-bind:value="{field: 'device_model.name', sort: 'asc'}">
                        Device Model: A to Z
                      </option>
                      <option v-bind:value="{field: 'device_model.name', sort: 'desc'}">
                        Device Model: Z to A
                      </option>
                      <option v-bind:value="{field: 'test_event', sort: 'asc'}">
                        Test Result: A to Z
                      </option>
                      <option v-bind:value="{field: 'test_event', sort: 'desc'}">
                        Test Result: Z to A
                      </option>
                      <option v-bind:value="{field: 'test_event_date', sort: 'asc'}">
                        LAST TEST DATE: Old to New
                      </option>
                      <option v-bind:value="{field: 'test_event_date', sort: 'desc'}">
                        LAST TEST DATE: New to Old
                      </option>
                    </select>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item" v-if="canAcceptTest && canTest">
                    <ToolTip>
                                        <span
                                            class="toolTip"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-html="true"
                                            title=""
                                            data-original-title='Selected devices will start an immediate test. The result will be on reports card.'
                                        >
                                            <button type="button" @click="resetManualTestModal();manualTestModal.showModal=true " v-bind:disabled="!checkedValue.selectedValue.length"
                                                    class="btn btn-primary buildingCard-body-btn">
                                                Test Selected ({{checkedValue.selectedValue.length}})
                                            </button>
                                        </span>
                    </ToolTip>
                  </div>
                  <div class="dropdown-item text-wrap" v-if="!canAcceptTest">
                    <p>There is a full building devices testing under going</p>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>

        <div class="clearfix d-none d-lg-block">
          <template v-if="!canAcceptTest">
            <p class="alert alert-warning"><strong>Please Note:</strong>The building is under full test</p>
          </template>
          <template v-else-if="neverTestedDevices.length">
            <p class="alert alert-warning text-dark">
              <span class="mr-2"><i class="fas fa-exclamation-triangle text-warnin"></i></span>
              One or more devices have never been tested. Click <a href="javascript:void(0)" v-on:click="neverTestedModal.showModal=true"><strong>Run Quick Test</strong></a> to run a quick test for all devices that have never been tested.
            </p>

          </template>
          <div class="buildingCard-right" v-if="showBuildingInformation">
            <template v-if="canAcceptTest && canTest">
              <ToolTip>
                            <span
                                class="toolTip"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-html="true"
                                title=""
                                data-original-title='Selected devices will start an immediate test. The result will be on reports card.'
                            >
                            <button type="button" @click="resetManualTestModal();manualTestModal.showModal=true" v-bind:disabled="!checkedValue.selectedValue.length"
                                    class="btn btn-primary btn-sm px-3 buildingCard-body-btn">
                                Test Selected ({{checkedValue.selectedValue.length}})
                            </button>
                        </span>
              </ToolTip>
            </template>

            <button type="button" @click="downloadCSV()" class="btn btn-primary btn-sm px-3 ml-3 buildingCard-body-btn">Download CSV</button>
          </div>
          <div class="buildingCard-flex" v-if="showBuildingInformation">
            <form novalidate v-on:submit.prevent class="buildingCard-flex-inner">

              <div class="btn-group buildingCard-body-btn-group" v-bind:title="levelFilterTitle">
                <button class="btn btn-sm buildingCard-body-btn dropdown-toggle px-2" v-bind:class="{'btn-outline-primary':!currentFilters.level.length, 'btn-primary': currentFilters.level.length}" type="button" id="currentFiltersLevel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{levelFilterTitle}}
                </button>
                <div class="dropdown-menu buildingCard-dropdown-menu" aria-labelledby="currentFiltersLevel">
                  <a class="dropdown-item" v-for="level in levels" href="javascript:void(0)" v-on:click="toggleList(level, 2, levelListFlat, currentFilters.level); client.currentPage = 1;">
                                    <span class="buildingCard-checkbox">
                                        <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': currentFilters.level.indexOf(JSON.stringify([level])) < 0}"></i></span>
                                        {{level}}
                                    </span>

                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)" v-on:click="currentFilters.level.splice(0); client.currentPage = 1;">
                    Reset Filter
                  </a>
                </div>
              </div>

              <div class="btn-group buildingCard-body-btn-group" v-bind:title="statusFilterTitle">
                <button class="btn btn-sm buildingCard-body-btn dropdown-toggle px-2" v-bind:class="{'btn-outline-primary':!currentFilters.status.length, 'btn-primary': currentFilters.status.length}" type="button" id="currentFiltersStatus" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{statusFilterTitle}}
                </button>
                <div class="dropdown-menu buildingCard-dropdown-menu" aria-labelledby="currentFiltersStatus">
                  <div v-for="(data, index) in deviceStatusList">
                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="toggleList(index, 1, deviceStatusListFlat, currentFilters.status); client.currentPage = 1;">
                                        <span class="buildingCard-checkbox">
                                            <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': currentFilters.status.indexOf(JSON.stringify([index])) < 0}"></i></span>
                                            {{data[0]}}
                                        </span>
                    </a>
                    <div v-if="data[1]" class="buildingCard-dropdown-menu-subList">
                      <a v-for="(subData, subIndex) in data[1]" class="dropdown-item" href="javascript:void(0)" v-on:click="toggleList(subIndex, 1, deviceStatusListFlat, currentFilters.status); client.currentPage = 1;">
                                            <span class="buildingCard-checkbox">
                                                <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': currentFilters.status.indexOf(JSON.stringify([index, subIndex])) < 0}"></i></span>
                                                {{subData[0]}}
                                            </span>
                      </a>
                    </div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)" v-on:click="currentFilters.status.splice(0); client.currentPage = 1;">
                    Reset Filter
                  </a>
                </div>
              </div>

              <div class="btn-group buildingCard-body-btn-group" v-bind:title="resultFilterTitle">
                <button class="btn btn-sm buildingCard-body-btn dropdown-toggle px-2" v-bind:class="{'btn-outline-primary':!currentFilters.test.length, 'btn-primary': currentFilters.test.length}" type="button" id="currentFiltersTest" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{resultFilterTitle}}
                </button>
                <div class="dropdown-menu buildingCard-dropdown-menu" aria-labelledby="currentFiltersTest">
                  <a class="dropdown-item" v-for="(data, index) in testStatusList" href="javascript:void(0)" v-on:click="toggleList(index, 2, testStatusList, currentFilters.test); client.currentPage = 1;">
                                    <span class="buildingCard-checkbox">
                                        <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': currentFilters.test.indexOf(JSON.stringify([index])) < 0}"></i></span>
                                        {{data[0]}}
                                    </span>
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)" v-on:click="currentFilters.test.splice(0); client.currentPage = 1;">
                    Reset Filter
                  </a>
                </div>
              </div>
              <div class="btn-group buildingCard-body-btn-group customSearchFilter buildingCard-flex-1-1">
                <div class="form-group buildingCard-flex-auto hasSearch">
                  <i class="fa fa-search hasSearch-icon hasSearch-icon-left"></i>
                  <input type="text" class="form-control hasSearch-formControl" v-model="currentFilters.search" v-on:keydown="client.currentPage = 1" placeholder="Search">
                </div>
              </div>

            </form>
          </div>
        </div>
        <div class="table-responsive-xl">
          <table class="table buildingCard-table buildingCard-table-lg" v-if="showBuildingInformation && pagedDevice.length">
            <thead>
            <tr>
              <th @click="sort('fitting_number')" class="sort w1">NO <i class="fas fa-sort"></i></th>
              <th @click="sort('device_model.name')" class="sort w1">MODEL <i class="fas fa-sort"></i></th>
              <th @click="sort('level')" class="sort w1">LEVEL <i class="fas fa-sort"></i></th>
              <th @click="sort('location')" class="sort w2">LOCATION <span class="locationDescription">DESCRIPTION</span><i class="fas fa-sort"></i></th>
              <th class="w1">STATUS</th>
              <th @click="sort('test_event')" class="sort w1">LAST TEST RESULT <i class="fas fa-sort"></i></th>
              <th @click="sort('test_event_date')" class="sort w1">LAST TEST DATE <i class="fas fa-sort"></i></th>
              <template v-if="canAcceptTest && canTest">
                <th class="w1">MANUAL TEST</th>
              </template>
              <th v-if="canEdit">EDIT</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(device,index) in pagedDevice" v-bind:key="device.id">
              <td data-title="Fitting Number" class="buildingCard-table-sub-float-left">
                <span>{{device.fitting_number}}</span>
              </td>
              <td data-title="Device Model" v-if="device.device_model">
                <ToolTip>
                                <span
                                    class="toolTip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    title=""
                                    v-bind:data-original-title='device.device_model.description'
                                >
                                {{device.device_model.name}}
                                </span>
                </ToolTip>

              </td>
              <td class="buildingCard-table-lg-none" v-else></td>
              <td data-title="Level">{{device.level}}</td>
              <td data-title="Location">{{device.location}}</td>
              <td data-title="Status" class="buildingCard-table-sub-float-left testResultIcon" v-if="deviceStatus[device.id] !== undefined && deviceStatus[device.id].length">
                <ToolTip v-for="(status, index) in deviceStatus[device.id]" v-bind:key="`${status}_${index}_${device.id}`" class="d-block">
                                <span v-bind:data-original-title="status['title'] ? status['title'] : `${status['status'] && status['timestamp'] ? tools.formatDateTimeWithOutSeconds(new Date(status['timestamp'] * 1000)) + '<br>' : ''}${deviceStatusListFlat[status['status']][0]}`" data-toggle="tooltip" data-placement="top" data-html="true">
                                    <span class="mr-2">
                                        <i class="fas" v-bind:class="deviceStatusListFlat[status['status']][3]"></i>
                                    </span>
                                    <span class="testStatus">{{deviceStatusListFlat[status['status']][0]}}</span>
                                </span>
                </ToolTip>
              </td>
              <td class="buildingCard-table-lg-none" v-else></td>

              <td v-if="Object.keys(testStatusList).length && testStatus[device.id] !== undefined && testStatus[device.id].length" data-title="Last Test Result">
                <ToolTip class="d-block">
                                <span v-bind:data-original-title="testStatus[device.id][2] ? testStatus[device.id][2] : testStatusList[testStatus[device.id][0]][0]" data-toggle="tooltip" data-placement="top" data-html="false">
                                    <span class="mr-2"><i v-bind:class="testStatusList[testStatus[device.id][0]][1]"></i></span>
                                    <span class="d-inline-block">{{testStatusList[testStatus[device.id][0]][0]}}</span>
                                </span>
                </ToolTip>
              </td>
              <td class="buildingCard-table-lg-none" v-else></td>


              <td data-title="Last Test Date" v-if="testStatus[device.id] !== undefined && testStatus[device.id].length && testStatus[device.id][1]">
                <ToolTip class="d-block">
                                <span v-bind:data-original-title="tools.formatDateTimeWithOutSeconds(new Date(testStatus[device.id][1] * 1000))" data-toggle="tooltip" data-placement="top" data-html="false">
                                    <!-- EMIOT-482 : 1262304001000 = 2010-01-01 00:00:01 -->
                                    {{testStatus[device.id][1] * 1000 < 1262304001000 ? 'Unknown' : tools.humanizedTimeSpan(new Date(testStatus[device.id][1] * 1000))}}
                                </span>
                </ToolTip>
              </td>
              <td class="buildingCard-table-lg-none" v-else></td>

              <template v-if="canAcceptTest && canTest">
                <td class="buildingCard-table-lg-footer" v-if="testType[device.id] === 'full'" data-title="Full discharge testing">
                  <div v-if="showProgressBar[device.id]">
                    <ToolTip class="d-block">
                      <a href="javascript:void(0)"
                         class="buildingCard-table-progress-container"
                         v-on:click="confirmCancelTest(device)">
                        <div class="progress buildingCard-table-progress"
                             v-bind:data-original-title="getPercentage(totalTestTime, timeDifference[device.id])"
                             data-toggle="tooltip"
                             data-placement="top"
                             data-html="false"
                             :title="getPercentage(totalTestTime, timeDifference[device.id])">
                          <div class="progress-bar buildingCard-table-progress-bar"
                               role="progressbar"
                               v-bind:style="myStyles(testPercentage[device.id])"
                               v-bind:aria-valuenow="testPercentage[device.id]"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <span class="buildingCard-table-progress-cancel"
                              data-original-title="cancel full discharge test"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-html="false">
                                                <i class="fas fa-times-circle text-danger"></i>
                                            </span>
                      </a>
                    </ToolTip>
                  </div>
                  <div v-else>
                    <ToolTip class="d-block text-nowrap">
                                        <span v-bind:data-original-title="testStatus[device.id][2] ? testStatus[device.id][2] : (timeWaiting[device.id] ? getTimeElapsed(timeWaiting[device.id], totalTestTime) : testStatusList[testStatus[device.id][0]][0])" data-toggle="tooltip" data-placement="top" data-html="false">
                                            <span class="mr-2"><i v-bind:class="testStatusList[testStatus[device.id][0]][1]"></i></span>
                                            <span class="d-inline-block" v-bind:title="testStatus[device.id][2] ? testStatus[device.id][2] : testStatusList[testStatus[device.id][0]][0]">
                                                {{testStatusList[testStatus[device.id][0]][0]}}
                                            </span>
                                        </span>
                      <a href="javascript:void(0)" v-on:click="confirmCancelTest(device)" v-if="isDisplay[device.id]"
                         class="ml-2"
                         data-original-title="cancel full discharge test"
                         data-toggle="tooltip"
                         data-placement="top"
                         data-html="false">
                        <i class="fas fa-times-circle text-danger"></i>
                      </a>
                    </ToolTip>
                  </div>
                </td>
                <td class="buildingCard-table-lg-footer" v-else-if="testType[device.id] === 'quick'" data-title="Quick Testing">
                  <div v-if="funcShowProgressBar[device.id]" class="d-block">
                    <ToolTip class="d-block">
                      <a href="javascript:void(0)"
                         class="buildingCard-table-progress-container"
                         v-on:click="confirmCancelTest(device)">
                        <div class="progress buildingCard-table-progress"
                             v-bind:data-original-title="getPercentage(totalFuncTestTime, funcTimeDifference[device.id])"
                             data-toggle="tooltip"
                             data-placement="top"
                             data-html="false"
                             :title="getPercentage(totalFuncTestTime, funcTimeDifference[device.id])">
                          <div class="progress-bar buildingCard-table-progress-bar buildingCard-table-progress-bar-quick"
                               role="progressbar"
                               v-bind:style="myStyles(funcTestPercentage[device.id])"
                               v-bind:aria-valuenow="funcTestPercentage[device.id]"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <span class="buildingCard-table-progress-cancel"
                              data-original-title="cancel quick test"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-html="false">
                                                    <i class="fas fa-times-circle text-danger"></i>
                                            </span>
                      </a>
                    </ToolTip>
                  </div>
                  <div v-else>
                    <ToolTip class="d-block text-nowrap">
                                        <span v-bind:data-original-title="funcTestStatus[device.id][2] ? funcTestStatus[device.id][2] : (funcTimeWaiting[device.id] ? getTimeElapsed(funcTimeWaiting[device.id], totalFuncTestTime) : funcTestStatusList[funcTestStatus[device.id][0]][0])" data-toggle="tooltip" data-placement="top" data-html="false">
                                            <span class="mr-2"><i v-bind:class="funcTestStatusList[funcTestStatus[device.id][0]][1]"></i></span>
                                            <span class="d-inline-block">
                                                {{funcTestStatusList[funcTestStatus[device.id][0]][0]}}
                                            </span>
                                        </span>
                      <a href="javascript:void(0)" v-on:click="confirmCancelTest(device)" class="ml-2"
                         data-original-title="cancel quick test"
                         data-toggle="tooltip"
                         data-placement="top"
                         data-html="false">
                        <i class="fas fa-times-circle text-danger"></i>
                      </a>
                    </ToolTip>
                  </div>
                </td>
                <td class="buildingCard-table-lg-footer" v-else-if="!device.device_model || device.device_model.test_type > 1">
                  <label class="d-block buildingCard-checkbox">
                    <input class="buildingCard-checkbox-input"
                           type="checkbox"
                           v-bind:name="'device-' + device.id"
                           v-bind:value="device.id"
                           v-model="checkedValue.selectedValue"/>
                    <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': checkedValue.selectedValue.indexOf(device.id) === -1}"></i></span>
                    <span>Select</span>
                  </label>
                </td>
                <td class="buildingCard-table-lg-footer" v-else>
                  N/A
                </td>
              </template>
              <td class="buildingCard-table-lg-none editDevice" v-if="canEdit">
                <template v-if="device.id">
                  <ToolTip>
                                        <span
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-html="true"
                                            title=""
                                            data-original-title='You can manage device information here'
                                        >
                                             <button v-on:click="edit(device)" class="deviceCard-edit">
                                                 <i class="fas fa-pen"></i>
                                                    <span class="sr-only">Edit</span>
                                             </button>
                                        </span>
                  </ToolTip>
                </template>
                <template v-else></template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <template v-if="client.totalPage > 1">
          <paginate
              v-model="client.currentPage"
              :page-count="client.totalPage"
              :click-handler="pageCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination justify-content-center'"
              :page-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'">
          </paginate>
        </template>
        <transition>
          <div class="alert alert-danger col-md-4 mx-auto mt-3" v-if="showErrorMessage">You are not authorised to
            view this Building Information
          </div>
        </transition>
      </div>
      <ModalComponent
          v-if="manualTestModal.showModal"
          @execute="testSelected();manualTestModal.showModal = false;resetManualTestModal();"
          @close="manualTestModal.showModal = false;resetManualTestModal();"
          :headerClassName="'modalDefault'"
          :executeBtnDisabled="manualTestModal.executeBtnDisabled"
          :executeBtnClassName="manualTestModal.executeBtnClassName"
          :executeBtnText="manualTestModalExecuteBtnText"
          :closeBtnText="manualTestModal.closeBtnText"
          :executing="manualTestModal.submitting"
          :confirm="manualTestModal"
      >
        <template v-slot:msg>

          <div class="custom-control custom-radio mb-3">
            <input type="radio" class="custom-control-input" v-bind:id="getId('manual_test_quick_test')" name="test_type" value="quick" required v-model="checkedValue.type"/>

            <label class="custom-control-label" v-bind:for="getId('manual_test_quick_test')">
              Quick test
            </label>
            <div>
              <p>A quick test lasts for 15 seconds and will check that:</p>

              <ul>
                <li>the emergency light is powered on and responding to commands</li>
                <li>the lamp(s) are functioning correctly</li>
                <li>the battery is connected and at the correct voltage</li>
              </ul>

              <p>Quick Test results will update the status of the device in the device list.</p>
            </div>
          </div>

          <div class="custom-control custom-radio mb-3">
            <input type="radio" class="custom-control-input" v-bind:id="getId('manual_test_full_discharge_test')" name="test_type" value="full" required v-model="checkedValue.type"/>

            <label class="custom-control-label" v-bind:for="getId('manual_test_full_discharge_test')">
              Full discharge test
            </label>
            <div>
              <p>A full discharge test lasts for 90+ minutes until the battery fully discharges. In addition to the quick test checks, the full discharge test will also verify that the battery lasts the full duration of 90 minutes.</p>
              <p>Full discharge test results will update the last test result and last test date of the device in the device list.</p>
            </div>
          </div>

        </template>
      </ModalComponent>
      <ModalComponent
          v-if="smokeAlarmTestModal.showModal"
          @execute="smokeAlarmTestSelected();smokeAlarmTestModal.showModal = false;resetSmokeAlarmTestModal();"
          @close="smokeAlarmTestModal.showModal = false;resetSmokeAlarmTestModal();"
          :headerClassName="'modalDefault'"
          :executeBtnDisabled="smokeAlarmTestModal.executeBtnDisabled"
          :executeBtnClassName="smokeAlarmTestModal.executeBtnClassName"
          :executeBtnText="smokeAlarmTestModalExecuteBtnText"
          :closeBtnText="smokeAlarmTestModal.closeBtnText"
          :executing="smokeAlarmTestModal.submitting"
          :confirm="smokeAlarmTestModal"
      >
        <template v-slot:msg>

          <div class="custom-control custom-radio mb-3">
            <input type="radio" class="custom-control-input" v-bind:id="getId('manual_test_quick_test')" name="test_type" value="quick" required v-model="checkedValue.type"/>

            <label class="custom-control-label" v-bind:for="getId('manual_test_quick_test')">
              Smoke alarm test
            </label>
            <div>
              <p>A smoke alarm test will take 5 seconds and will check that:</p>

              <ul>
                <li>the smoke sensor is functioning correctly</li>
                <li>the buzzer sounds at the correct volume</li>
                <li>the battery is connected and at the correct voltage</li>
              </ul>
            </div>
          </div>
        </template>
      </ModalComponent>
      <ModalComponent
          v-if="neverTestedModal.showModal"
          @execute="testNeverTested('quick');neverTestedModal.showModal = false;resetNeverTestedModal();"
          @close="neverTestedModal.showModal = false;resetNeverTestedModal();"
          :headerClassName="'modalDefault'"
          :executeBtnDisabled="neverTestedModal.executeBtnDisabled"
          :executeBtnClassName="neverTestedModal.executeBtnClassName"
          :executeBtnText="'Run Quick Test'"
          :closeBtnText="neverTestedModal.closeBtnText"
          :executing="neverTestedModal.submitting"
          :confirm="neverTestedModal"
      >
        <template v-slot:msg>
          <p>This will start a quick test for all never tested devices in the building immediately. A quick test lasts for 5 minutes and will check that:</p>
          <ul>
            <li><p>the emergency light is powered on and responding to commands</p></li>
            <li><p>the lamp(s) are functioning correctly</p></li>
            <li><p>the battery is connected and at the correct voltage</p></li>
          </ul>
          <p>A quick test will not verify that the battery lasts the full duration of 90 minutes and is not intended to replace a full discharge test.</p>
        </template>
      </ModalComponent>
      <DeviceEditModalComponent v-if="dataToPassToDeviceEditModal.showModal"
                                @close="dataToPassToDeviceEditModal.showModal = false"
                                @update="updateDevice($event)"
                                :fittingTypes="fittingTypes"
                                :deviceModels="deviceModels"
                                :testResult = "testStatus[dataToPassToDeviceEditModal.deviceId]"
                                :funcTestResult = "funcTestStatus[dataToPassToDeviceEditModal.deviceId]"
                                :testStatusList = "testStatusList"
                                :dataToPassToModal="dataToPassToDeviceEditModal"
      ></DeviceEditModalComponent>
      <ModalComponent v-if="dataToPassToDeviceTestCancelModal.showModal"
                      @close="resetCancelTest()"
                      @execute="cancelTest(dataToPassToDeviceTestCancelModal.id).then(() => resetCancelTest())"

                      :headerClassName="'modalDefault'"
                      :executeBtnDisabled="dataToPassToDeviceTestCancelModal.executeBtnDisabled"
                      :executeBtnClassName="dataToPassToDeviceTestCancelModal.executeBtnClassName"
                      :executeBtnText="dataToPassToDeviceTestCancelModal.executeBtnText"
                      :closeBtnText="dataToPassToDeviceTestCancelModal.closeBtnText"
                      :executing="dataToPassToDeviceTestCancelModal.submitting"
                      :confirm="dataToPassToDeviceTestCancelModal"></ModalComponent>
    </div>
    <div class="card buildingCard" v-if="buildingProcessedId">
      <div class="card-body buildingCard-body"  v-if="!showBuildingInformation">
        <h5 class="card-title buildingCard-title">
                 <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          Smoke Alarms
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title="Smoke alarms aren't tested by EMIoT and don't count towards total devices, errors, warnings, or OK"
              ></i>
            </sup>
          </ToolTip>
        </h5>
        <div class="text-center" v-if="!noDevicesFound">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="text-center" v-else>
          <p>No Devices Found</p>
        </div>
      </div>
      <div class="card-body buildingCard-body" v-else-if="testStatusRawMapping !== undefined">
        <h5 class="card-title buildingCard-title">
                <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          Smoke Alarms
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title="Smoke alarms aren't tested by EMIoT and don't count towards total devices, errors, warnings, or OK"
              ></i>
            </sup>
          </ToolTip>
          <div class="buildingCard-right" v-if="showBuildingInformation">
            <template v-if="canAcceptTest && canTest">
              <ToolTip>
                            <span
                                class="toolTip"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-html="true"
                                title=""
                                data-original-title='Selected devices will start an immediate test.'
                            >
                            <button type="button" @click="resetSmokeAlarmTestModal();smokeAlarmTestModal.showModal=true" v-bind:disabled="!smokeAlarmCheckedValue.selectedValue.length"
                                    class="btn btn-primary btn-sm px-3 buildingCard-body-btn">
                                Test Selected ({{smokeAlarmCheckedValue.selectedValue.length}})
                            </button>
                        </span>
              </ToolTip>
            </template>
          </div>
        </h5>
        <div class="table-responsive-xl">
          <table class="table buildingCard-table buildingCard-table-lg" v-if="showBuildingInformation && pagedSmokeAlarmDevices.length">
            <thead>
            <tr>
              <th @click="smokeAlarmSort('fitting_number')" class="sort w1">NO <i class="fas fa-sort"></i></th>
              <th @click="smokeAlarmSort('device_model.name')" class="sort w1">MODEL <i class="fas fa-sort"></i></th>
              <th @click="smokeAlarmSort('level')" class="sort w1">LEVEL <i class="fas fa-sort"></i></th>
              <th @click="smokeAlarmSort('location')" class="sort w2">LOCATION <span class="locationDescription">DESCRIPTION</span><i class="fas fa-sort"></i></th>
              <th @click="smokeAlarmSort('test_event')" class="sort w1">LAST TEST RESULT <i class="fas fa-sort"></i></th>
              <th @click="smokeAlarmSort('test_event_date')" class="sort w1">LAST TEST DATE <i class="fas fa-sort"></i></th>
              <template v-if="canAcceptTest && canTest">
                <th class="w1">MANUAL TEST</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(device,index) in pagedSmokeAlarmDevices" v-bind:key="device.id">
              <td data-title="Fitting Number" class="buildingCard-table-sub-float-left">
                <span>{{device.fitting_number}}</span>
              </td>
              <td data-title="Device Model" v-if="device.device_model">
                <ToolTip>
                                <span
                                    class="toolTip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    title=""
                                    v-bind:data-original-title='device.device_model.description'
                                >
                                {{device.device_model.name}}
                                </span>
                </ToolTip>

              </td>
              <td class="buildingCard-table-lg-none" v-else></td>
              <td data-title="Level">{{device.level}}</td>
              <td data-title="Location">{{device.location}}</td>

              <td v-if="Object.keys(funcTestStatusList).length && funcTestStatus[device.id] !== undefined && funcTestStatus[device.id].length" data-title="Last Test Result">
                <ToolTip class="d-block">
                                <span v-bind:data-original-title="funcTestStatus[device.id][2] ? funcTestStatus[device.id][2] : funcTestStatusList[funcTestStatus[device.id][0]][0]" data-toggle="tooltip" data-placement="top" data-html="false">
                                    <span class="mr-2"><i v-bind:class="funcTestStatusList[funcTestStatus[device.id][0]][1]"></i></span>
                                    <span class="d-inline-block">{{funcTestStatusList[funcTestStatus[device.id][0]][0]}}</span>
                                </span>
                </ToolTip>
              </td>
              <td class="buildingCard-table-lg-none" v-else></td>


              <td data-title="Last Test Date" v-if="funcTestStatus[device.id] !== undefined && funcTestStatus[device.id].length && funcTestStatus[device.id][1]">
                <ToolTip class="d-block">
                                <span v-bind:data-original-title="tools.formatDateTimeWithOutSeconds(new Date(funcTestStatus[device.id][1] * 1000))" data-toggle="tooltip" data-placement="top" data-html="false">
                                    <!-- EMIOT-482 : 1262304001000 = 2010-01-01 00:00:01 -->
                                    {{funcTestStatus[device.id][1] * 1000 < 1262304001000 ? 'Unknown' : tools.humanizedTimeSpan(new Date(funcTestStatus[device.id][1] * 1000))}}
                                </span>
                </ToolTip>
              </td>
              <td class="buildingCard-table-lg-none" v-else></td>

              <template v-if="canAcceptTest && canTest">
                <td class="buildingCard-table-lg-footer" v-if="testType[device.id] === 'quick'" data-title="Quick Testing">
                  <ToolTip class="d-block text-nowrap">
                                        <span v-bind:data-original-title="funcTestStatus[device.id][2] ? funcTestStatus[device.id][2] : (funcTimeWaiting[device.id] ? getTimeElapsed(funcTimeWaiting[device.id], totalFuncTestTime) : funcTestStatusList[funcTestStatus[device.id][0]][0])" data-toggle="tooltip" data-placement="top" data-html="false">
                                            <span class="mr-2"><i v-bind:class="funcTestStatusList[funcTestStatus[device.id][0]][1]"></i></span>
                                            <span class="d-inline-block">
                                                {{funcTestStatusList[funcTestStatus[device.id][0]][0]}}
                                            </span>
                                        </span>
                    <a href="javascript:void(0)" v-on:click="confirmCancelTest(device)" class="ml-2"
                       data-original-title="cancel quick test"
                       data-toggle="tooltip"
                       data-placement="top"
                       data-html="false">
                      <i class="fas fa-times-circle text-danger"></i>
                    </a>
                  </ToolTip>
                </td>
                <td class="buildingCard-table-lg-footer" v-else>
                  <label class="d-block buildingCard-checkbox">
                    <input class="buildingCard-checkbox-input"
                           type="checkbox"
                           v-bind:name="'device-' + device.id"
                           v-bind:value="device.id"
                           v-model="smokeAlarmCheckedValue.selectedValue"/>
                    <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': smokeAlarmCheckedValue.selectedValue.indexOf(device.id) === -1}"></i></span>
                    <span>Select</span>
                  </label>
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
        <template v-if="smokeAlarmPagination.totalPage > 1">
          <paginate
              v-model="smokeAlarmPagination.currentPage"
              :page-count="smokeAlarmPagination.totalPage"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination justify-content-center'"
              :page-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'">
          </paginate>
        </template>
      </div>
    </div>
    <div class="card buildingCard" v-if="buildingProcessedId">
      <div class="card-body buildingCard-body"  v-if="!showBuildingInformation">
        <h5 class="card-title buildingCard-title">
                 <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          Non-emergency Devices
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title="Non-emergency lights aren't tested by EMIoT and don't count towards total devices, errors, warnings, or OK"
              ></i>
            </sup>
          </ToolTip>
        </h5>
        <div class="text-center" v-if="!noDevicesFound">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="text-center" v-else>
          <p>No Devices Found</p>
        </div>
      </div>
      <div class="card-body buildingCard-body" v-else-if="testStatusRawMapping !== undefined">
        <h5 class="card-title buildingCard-title">
                <span class="iconBeforeTitle">
                    <i class="fas fa-th-list"></i>
                 </span>
          Non-emergency Devices
          <ToolTip>
            <sup class="superScript">
              <i class="fas fa-info-circle"
                 data-toggle="tooltip"
                 data-placement="top"
                 data-html="true"
                 title=""
                 data-original-title="Non-emergency lights aren't tested by EMIoT and don't count towards total devices, errors, warnings, or OK"
              ></i>
            </sup>
          </ToolTip>
        </h5>
        <div class="table-responsive-xl">
          <table class="table buildingCard-table buildingCard-table-lg" v-if="showBuildingInformation && pagedNonEmergencyDevices.length">
            <thead>
            <tr>
              <th @click="nonEmergencySort('fitting_number')" class="sort w1">NO <i class="fas fa-sort"></i></th>
              <th @click="nonEmergencySort('device_model.name')" class="sort w1">MODEL <i class="fas fa-sort"></i></th>
              <th @click="nonEmergencySort('level')" class="sort w1">LEVEL <i class="fas fa-sort"></i></th>
              <th @click="nonEmergencySort('location')" class="sort w2">LOCATION <span class="locationDescription">DESCRIPTION</span><i class="fas fa-sort"></i></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(device,index) in pagedNonEmergencyDevices" v-bind:key="device.id">
              <td data-title="Fitting Number" class="buildingCard-table-sub-float-left">
                <span>{{device.fitting_number}}</span>
              </td>
              <td data-title="Device Model" v-if="device.device_model">
                <ToolTip>
                                <span
                                    class="toolTip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    title=""
                                    v-bind:data-original-title='device.device_model.description'
                                >
                                {{device.device_model.name}}
                                </span>
                </ToolTip>

              </td>
              <td class="buildingCard-table-lg-none" v-else></td>
              <td data-title="Level">{{device.level}}</td>
              <td data-title="Location">{{device.location}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <template v-if="nonEmergencyPagination.totalPage > 1">
          <paginate
              v-model="nonEmergencyPagination.currentPage"
              :page-count="nonEmergencyPagination.totalPage"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination justify-content-center'"
              :page-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'">
          </paginate>
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/../sass/_building_card.scss";
</style>
<script>
/**
 * @typedef {Object} updateMeta The meta data feed for device via API endpoint
 * @property {int} updateMeta.id - id
 * @property {int} updateMeta.last_comm - device last communication cloud timestamp
 * @property {string} updateMeta.meta_mains_event - device mains event
 * @property {timestamp} updateMeta.meta_mains_event_datetime - mains event device timestamp
 * @property {string} updateMeta.meta_battery_event - device battery event
 * @property {timestamp} updateMeta.meta_battery_event_datetime - battery event device timestamp
 * @property {string} updateMeta.meta_test_event - device test event
 * @property {timestamp} updateMeta.meta_test_event_datetime - test event device timestamp
 * @property {string} updateMeta.meta_lamp_event - device lamp event
 * @property {timestamp} updateMeta.meta_lamp_event_datetime - lamp event device timestamp
 * @property {string} updateMeta.meta_discharge_event - device discharge event
 * @property {timestamp} updateMeta.meta_discharge_event_datetime - discharge event device timestamp
 * @property {string} updateMeta.meta_schedule_event - device schedule event
 * @property {timestamp} updateMeta.meta_schedule_event_datetime - schedule event device timestamp
 * @property {string} updateMeta.meta_status - device status
 * @property {timestamp} updateMeta.meta_status_datetime - device status cloud timestamp
 * @property {timestamp} updateMeta.meta_test_event_time - test event cloud timestamp
 *
 * @typeof {Object} DeviceTestStatus - device test status
 * @property {string} DeviceTestStatus[0] - title text
 * @property {string} DeviceTestStatus[1] - desc text
 * @property {timestamp} DeviceTestStatus[2] - event timestamp
 *
 * @typeof {Object} DeviceStatus - Device status from IoT network
 * @property {string} DeviceStatus[0] - Title Text
 * @property {timestamp} DeviceStatus[1] - Event Timestamp
 * @property {string} DeviceStatus[2] - key match for this.deviceStatusList
 * @property {string} [DeviceStatus[3]] - Optional Tool Tip text, leave empty, tool tips would use `${DeviceStatus[0]} ${DeviceStatus[1] convert to Date time}`
 *
 * @typeof {Object} nameMapping - mapping object for title, css; key is used for mapping
 * @property {mappingItem} nameMapping.{string}
 *
 * @typeof {Array} mappingItem
 * @property {string} mappingItem[0] - title text
 * @property {string} mappingItem[1] - css class
 * @property {nameMapping} mappingItem[2] - sub mapping
 *
 * @typeof {Object} flatNameMapping - flatted mapping object for title, css; key is used for mapping
 * @property {mappingItem} flatNameMapping.{string}
 *
 * @typeof {Array} flatNameMappingItem
 * @property {string} flatNameMappingItem[0] - title text
 * @property {string} flatNameMappingItem[1] - css class
 * @property {int} flatNameMappingItem[2] - parent key
 */
import Tools from '@/app-model/tools.js';
import DeviceEditModalComponent from '@/components/modal/DeviceEditModalComponent.vue';
import DeleteModalComponent from '@/components/modal/DeleteModalComponent.vue';
import ModalComponent from '@/components/modal/ModalComponent.vue';
import Vue from 'vue';
import lozad from 'lozad';
import ToolTip from '@/components/tool-tip/ToolTip.vue'
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";

export default {
    props: {
      pageTitle: String,
      deviceModels: Object,
      buildingId: Number|String,
      eventHub: Object
    },
    data () {
      return {
        deviceSearchInfo: {},
        hadFullTest: true,
        noDevicesFound:false,
        observer: undefined,
        totalPage: undefined,
        currentPage: undefined,
        metaUpdate: {
          totalPage: undefined,
          currentPage: undefined,
        },
        client: {
          totalPage: 0,
          currentPage: 1,
          perPage: 20,
        },
        currentFilters: {
          level: [],
          status: [],
          test: [],
          search: '',
        },
        currentSort: {
          field: 'fitting_number',
          sort: 'asc',
        },
        currentSmokeAlarmSort: {
          field: 'fitting_number',
          sort: 'asc',
        },
        currentNonEmergencySort: {
          field: 'fitting_number',
          sort: 'asc',
        },
        smokeAlarmPagination: {
          totalPage: 0,
          currentPage: 1,
          perPage: 20,
        },
        nonEmergencyPagination: {
          totalPage: 0,
          currentPage: 1,
          perPage: 20,
        },
        filter: {
          'fitting_type.name': undefined,
          'level': undefined,
          'location': undefined,
          'device_model.name': undefined,
        },
        levels: [],
        locations: [],
        deviceStatusStyleMapping: {
          'status_error': ['fa-times-circle text-danger'],
          'status_warning': ['fa-exclamation-triangle text-warnin'],
          'status_ok': ['fa-check-circle text-success'],
        },
        deviceStatusListFlatRaw: {},
        testStatusRawMapping: {},
        funcTestStatusRawMapping: {},
        testStatusStyleMapping: {
          'communicating': ['fas fa-hourglass-start text-warnin'],
          'delayed': ['fas fa-hourglass-start text-warnin'],
          'waiting': ['fas fa-hourglass-start text-warnin'],
          'testing': ['fas fa-hourglass-start text-warnin'],
          'passed': ['far fa-check-circle text-success'],
          'failed': ['far fa-times-circle text-danger'],
          'canceled': ['fas fa-ban text-warnin'],
          'unable_to_test': ['fas fa-exclamation-triangle text-warnin'],
          'loss_connection': ['fas fa-exclamation-triangle text-warnin'],
        },
        updatedTime: [],
        deviceUpdates: [],
        deviceStatus: {},
        checkedValue: {
          selectedValue: [],
          type: 'quick',
        },
        smokeAlarmCheckedValue: {
          selectedValue: [],
          type: 'quick',
        },
        manualTestModal: {
          buildingId: '',
          showModal: false,
          submitting: false,
          executeBtnDisabled: false,
          executeBtnClassName:'btn-primary',
          executeBtnText: undefined,
          closeBtnText: 'Cancel',
          title: 'Test Selected Devices',
          msg: undefined,
        },
        smokeAlarmTestModal: {
          buildingId: '',
          showModal: false,
          submitting: false,
          executeBtnDisabled: false,
          executeBtnClassName:'btn-primary',
          executeBtnText: undefined,
          closeBtnText: 'Cancel',
          title: 'Test Selected Devices',
          msg: undefined,
        },
        neverTestedModal: {
          buildingId: '',
          showModal: false,
          submitting: false,
          executeBtnDisabled: false,
          executeBtnClassName:'btn-primary',
          executeBtnText: undefined,
          closeBtnText: 'Cancel',
          title: 'Run quick test?',
          msg: undefined,
        },

        testStatus: {},
        isDisplay: {},
        isDisplayTestStatus: {},
        timeWaiting: {},
        timeDifference: {},
        testPercentage: {},
        showProgressBar: {},

        funcTestStatus: {},
        funcIsDisplay: {},
        funcIsDisplayTestStatus: {},
        funcTimeWaiting: {},
        funcTimeDifference: {},
        funcTestPercentage: {},
        funcShowProgressBar: {},

        testType: {},

        moreInfo: false,
        id: undefined,
        devices: [],
        smokeAlarmDevices: [],
        nonEmergencyDevices: [],
        totalTestTime: 4 * 60 * 60 * 1000,
        totalFuncTestTime: 5 * 60 * 1000,
        showBuildingInformation: false,
        showErrorMessage: false,
        allSelected: false,
        serverTimeStamp: '',
        canAcceptTest: false,
        timerGetUpdatesWhenTimeIsNotNull: undefined,
        timerPreloadData: undefined,

        preloadLoading: true,
        setPreloadLoadingState: () => {
          this.preloadLoading = false;
        },
        dataToPassToDeviceEditModal: {
          showModal: false,
          deviceId: undefined,
          buildingId: undefined,
        },
        dataToPassToDeviceTestCancelModal: {
          id: '',
          showModal: false,
          submitting: false,
          executeBtnDisabled: false,
          executeBtnClassName:'btn-danger',
          executeBtnText: undefined,
          closeBtnText: 'Cancel',
          title: '',
          msg: undefined,
        },
        fittingTypes:[],
        destroyed: false,
      }
    },
    components: {
      DeviceEditModalComponent,
      DeleteModalComponent,
      ModalComponent,
      ToolTip,
      RequiresGlobalPermissions,
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      manualTestModalExecuteBtnText() {
        return this.manualTestModal.executeBtnText ? this.manualTestModal.executeBtnText :
          (`Run ${this.checkedValue.type === 'quick' ? 'Quick Test' : 'Full Discharge Test' }`);
      },
      smokeAlarmTestModalExecuteBtnText() {
        return 'Run smoke alarm test';
      },
      neverTestedDevices() {
        let deviceStatusListFlat = this.deviceStatusListFlat,
          deviceStatus = this.deviceStatus,
          devices = this.tools.noRefData(this.devices);

        return this.tools.filter(
          {
            status: [
              '["status_warning","never_tested"]',
            ]
          },
          devices,
          {
            'status': {
              select: (device) => {
                let data = deviceStatus?.[device?.id];
                return data ? data : [];
              },
              where: (filterValues, value) => {
                value = value ? value : '';

                if(filterValues.length < 1) {
                  return true;
                }

                for(let i = 0; i < filterValues.length; i++) {
                  let filterValue = filterValues[i];
                  if (value.findIndex(el => JSON.stringify(deviceStatusListFlat[el['status']][2]) === filterValue) > -1) {
                    return true;
                  }
                }
                return false;
              }
            },
          }
        ).filter(device => {
          return !this.testStatus?.[device.id]?.[0] && !this.funcTestStatus?.[device.id]?.[0];
        });
      },
      /**
       * @return {nameMapping}
       **/
      testStatusList() {
        let keys = Object.keys(this.testStatusRawMapping);
        keys.sort();
        return keys.reduce((accumulator, currentValue, currentIndex) => {
          accumulator[currentValue] = [ this.testStatusRawMapping[currentValue] ];
          accumulator[currentValue].push(...this.testStatusStyleMapping[currentValue]);
          return accumulator;
        }, {});
      },
      funcTestStatusList() {
        let keys = Object.keys(this.funcTestStatusRawMapping);
        keys.sort();
        return keys.reduce((accumulator, currentValue, currentIndex) => {
          accumulator[currentValue] = [ this.funcTestStatusRawMapping[currentValue] ];
          accumulator[currentValue].push(...this.testStatusStyleMapping[currentValue]);
          return accumulator;
        }, {});
      },
      /**
       * merge deviceStatusListFlatRaw with deviceEventCheckList to support error detailed status
       *
       * @return {flatNameMapping}
       */
      deviceStatusListFlat() {
        let keys = Object.keys(this.deviceStatusListFlatRaw);
        keys.sort((a, b) => {
          let nameA = a.toUpperCase(), nameB = b.toUpperCase(); // ignore upper and lowercase
          if (['status_error', 'status_warning', 'status_ok'].indexOf(a) > -1 ) return 1;
          if (nameA < nameB) return -1;
          return nameA > nameB;
        });
        return keys.reduce((accumulator, currentValue, currentIndex) => {
          let topParent = this.tools.getParentList(currentValue, 'parent', this.deviceStatusListFlatRaw);
          accumulator[currentValue] = [
            this.deviceStatusListFlatRaw[currentValue].name,
            this.deviceStatusListFlatRaw[currentValue].parent,
            topParent,
          ];
          accumulator[currentValue].push(...this.deviceStatusStyleMapping[topParent[0]]);
          return accumulator;
        }, {});
      },
      /**
       * @return {nameMapping}
       **/
      deviceStatusList() {
        return this.tools.buildTree(undefined, 1, Object.assign({}, this.deviceStatusListFlat));
      },
      levelListFlat () {
        let levels = {};
        for (let i = 0; i < this.levels.length; i++) {
          levels[levels[i]] = [levels[i]];
        }
        return levels;
      },
      canEdit() {
        return this.$store.getters.hasSitePermissions({siteId: this.id, requiredPermissions: ['WRITE']});
      },
      levelFilterTitle() {
        let mapping = {};
        for(let i = 0; i < this.levels.length; i++) {
          let level = this.levels[i];
          mapping[level] = [level, level];
        }
        return this.getTitle(this.currentFilters.level, mapping, 'Level Filter');
      },
      statusFilterTitle() {
        return this.getTitle(this.currentFilters.status, this.deviceStatusList, 'Device Status Filter');
      },
      resultFilterTitle() {
        return this.getTitle(this.currentFilters.test, this.testStatusList, 'Test Result Filter');
      },
      pagedDevice: function() {
        let start = (this.client.currentPage - 1) * this.client.perPage,
          end = start + this.client.perPage;
        this.client.totalPage = parseInt(Math.ceil(this.sortedDevices.length / this.client.perPage));
        return this.sortedDevices.slice(start, end);
      },
      sortedDevices () {
        if(!this.showBuildingInformation) {
          return [];
        }

        let fieldsInChain = this.tools.chainFields(this.currentSort.field),
          currentFilters = this.currentFilters,
          currentSort = this.currentSort,
          deviceStatusListFlat = this.deviceStatusListFlat,
          deviceStatus = this.deviceStatus,
          testStatus = this.testStatus,
          devices = this.tools.noRefData(this.devices);

        devices = this.tools.filter(
          currentFilters,
          devices,
          {
            'level': {
              undefinedValue: 'N/A',
              filterValueConvert: (filterValue) => {
                let convertedFilterValue = [];
                for (let i = 0; i < filterValue.length; i++) {
                  convertedFilterValue.push(JSON.parse(filterValue[i])[0]);
                }
                return convertedFilterValue;
              }
            },
            'status': {
              select: (device) => {
                let data = deviceStatus?.[device?.id];
                return data ? data : [];
              },
              where: (filterValues, value) => {
                value = value ? value : '';

                if(filterValues.length < 1) {
                  return true;
                }

                for(let i = 0; i < filterValues.length; i++) {
                  let filterValue = filterValues[i];
                  if (value.findIndex(el => JSON.stringify(deviceStatusListFlat[el['status']][2]) === filterValue) > -1) {
                    return true;
                  }
                }
                return false;
              }
            },
            'test': {
              select: (device) => {
                return testStatus?.[device.id]?.[0];
              },
              filterValueConvert: (filterValue) => {
                let convertedFilterValue = [];
                for (let i = 0; i < filterValue.length; i++) {
                  convertedFilterValue.push(JSON.parse(filterValue[i])[0]);
                }
                return convertedFilterValue;
              },
              where: (filterValues, sourceValue) => {
                return filterValues.indexOf(sourceValue) > -1 ||
                  (
                    filterValues.indexOf('loss_connection') > -1 && sourceValue === undefined
                  );
              }
            },
            'search': {
              select: (device) => {
                let info = [];
                info.push(`No ${device.fitting_number}`);
                info.push(`Type ${device.fitting_type ? device.fitting_type.name : 'N/A'}`);
                info.push(`Level ${device.level}`);
                info.push(`LOCATION DESCRIPTION ${device.location}`);
                info.push(`MODEL ${device.device_model ? device.device_model.name : 'N/A'}`);
                if (this.deviceSearchInfo[device.id]) {
                  info.push(...this.deviceSearchInfo[device.id]);
                }

                let haystack = [];
                for(let i = 0; i < info.length; i++) {
                  haystack.push((' ' + info[i] + ' ').replace(/\,/g, ' ').replace(/\s+/g, ' '));
                }

                return haystack.join(', ').toLowerCase();
              },
              where: (filterValue, haystack) => {
                filterValue = filterValue ? filterValue.split(',') : [];
                for(let i = 0; i < filterValue.length; i++) {
                  let needle = filterValue[i].replace(/\,/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
                  if(haystack.indexOf(needle) === -1) {
                    return false;
                  }
                }

                return true;
              }
            },
          }
        );

        devices = this.tools.sort(
          devices,
          fieldsInChain,
          currentSort.sort !== 'desc',
          true,
          {numeric: true, sensitivity: 'base'},
          {
            test_event: (a, b) => {
              return {
                aData: testStatus?.[a.id]?.[0],
                bData: testStatus?.[b.id]?.[0]
              }
            },
            test_event_date: (a, b) => {
              return {
                aData: testStatus?.[a.id]?.[1],
                bData: testStatus?.[b.id]?.[1]
              }
            },
          }
        );

        this.tools.setUrlHashByData(this, ['currentFilters', 'currentSort'], {buildingId: this.buildingId}, `building-${this.buildingId}`, false);

        return devices;
      },
      pagedSmokeAlarmDevices: function() {
        let start = (this.smokeAlarmPagination.currentPage - 1) * this.smokeAlarmPagination.perPage,
            end = start + this.smokeAlarmPagination.perPage;
        this.smokeAlarmPagination.totalPage = parseInt(Math.ceil(this.sortedSmokeAlarmDevices.length / this.smokeAlarmPagination.perPage));
        return this.sortedSmokeAlarmDevices.slice(start, end);
      },
      sortedSmokeAlarmDevices () {
        if(!this.showBuildingInformation) {
          return [];
        }

        let fieldsInChain = this.tools.chainFields(this.currentSmokeAlarmSort.field),
            currentSort = this.currentSmokeAlarmSort,
            devices = this.tools.noRefData(this.smokeAlarmDevices);

        devices = this.tools.sort(
            devices,
            fieldsInChain,
            currentSort.sort !== 'desc',
            true,
            {numeric: true, sensitivity: 'base'},
        );

        return devices;
      },
      pagedNonEmergencyDevices: function() {
        let start = (this.nonEmergencyPagination.currentPage - 1) * this.nonEmergencyPagination.perPage,
            end = start + this.nonEmergencyPagination.perPage;
        this.nonEmergencyPagination.totalPage = parseInt(Math.ceil(this.sortedNonEmergencyDevices.length / this.nonEmergencyPagination.perPage));
        return this.sortedNonEmergencyDevices.slice(start, end);
      },
      sortedNonEmergencyDevices () {
        if(!this.showBuildingInformation) {
          return [];
        }

        let fieldsInChain = this.tools.chainFields(this.currentNonEmergencySort.field),
            currentSort = this.currentNonEmergencySort,
            devices = this.tools.noRefData(this.nonEmergencyDevices);

        devices = this.tools.sort(
            devices,
            fieldsInChain,
            currentSort.sort !== 'desc',
            true,
            {numeric: true, sensitivity: 'base'},
        );

        return devices;
      },
      canTest () {
        return this.$store.getters.hasSitePermissions({siteId: this.id, requiredPermissions: ['WRITE']});
      },
      buildingProcessedId: function () {
        return this.buildingId;
      }
    },
    mounted () {
      this.destroyed = false;
      this.id = this.buildingId;

      let top = this,
        buildingId = this.id;

      this.removeTimer();
      top.timerPreloadData = setTimeout(function() {
        top.removeTimer();
        if(!top.destroyed && buildingId === top.id) {
          top.$el.setAttribute('data-loaded', false);
          top.observer = lozad(
            top.$el,
            {
              load: function(el) {
                top.getLocations(buildingId);
                top.fetchDevices(buildingId);
                top.getFittingTypes(buildingId);
              }
            }
          );
          top.observer.observe();
        }
      }, 2000); // delay 2 seconds to load the data, to make sure lazy load works
    },
    created () {
      let mapping = {};
      Object.keys(this.currentFilters).forEach(el => {
        if(this.tools.isArrayish(this.currentFilters[el])) {
          mapping[el] = Array;
        }
        else if (this.tools.isString(this.currentFilters[el])) {
          mapping[el] = String;
        }
        else {
          mapping[el] = undefined;
        }
      });

      this.tools.getDataFromUrlHash(this, ['currentFilters', 'currentSort']);

      Object.keys(mapping).forEach(el => {
        /**
         * reset old version data which was from URL
         */
        if(mapping[el] === Array && !this.tools.isArrayish(this.currentFilters[el])) {
          this.currentFilters[el] = [];
        }
        else if (mapping[el] === String && this.tools.isArrayish(this.currentFilters[el])) {
          this.currentFilters[el] = '';
        }
      });

      if (this.eventHub !== undefined) {
        this.eventHub.$on('filterChange', (index) => {
          let top = this;
          let fn = () => {
            if (Object.keys(this.deviceStatusListFlat).length) {
              this.currentFilters.status = [];
              this.toggleList(index, 1, this.deviceStatusListFlat, this.currentFilters.status);
              this.client.currentPage = 1;
            }
            else {
              recheck();
            }
          };
          let recheck = function() {
            setTimeout(function() {
              fn();
            }, 200);
          };

          fn();
        });
      }
    },
    beforeDestroy () {
      this.destroyed = true;
      this.removeTimer();
    },
    methods: {
      applyServerTime(serverTimeStamp) {
        serverTimeStamp = parseInt(serverTimeStamp);
        // only accept bigger time number, time number can never go back
        if (serverTimeStamp > this.serverTimeStamp) {
          this.serverTimeStamp = serverTimeStamp;
        }
      },
      getId(postfix, ref = false) {
        return this.tools.getId(this, 'DeviceListCard', postfix, ref);
      },
      getTimeElapsed(timeWaiting, totalTime) {
        let unit = 'second',
          numerator = Math.round(timeWaiting / 1000);

        if (numerator > 60) {
          numerator = Math.round(numerator / 60);
          unit = 'minute';
        }

        return `${numerator} ${unit}${numerator === 1 ? '' : 's'} elapsed`
      },
      resetManualTestModal () {
        this.manualTestModal.buildingId = this.buildingId;
        this.manualTestModal.showModal = false;
        this.manualTestModal.executeBtnDisabled = false;
        this.manualTestModal.submitting = false;
        this.manualTestModal.executeBtnClassName = 'btn-primary';
        this.manualTestModal.executeBtnText = undefined;
        this.manualTestModal.title = 'Test Selected Devices';
        this.manualTestModal.closeBtnText = 'Cancel';
        this.manualTestModal.msg = undefined;
      },
      resetSmokeAlarmTestModal () {
        this.smokeAlarmTestModal.buildingId = this.buildingId;
        this.smokeAlarmTestModal.showModal = false;
        this.smokeAlarmTestModal.executeBtnDisabled = false;
        this.smokeAlarmTestModal.submitting = false;
        this.smokeAlarmTestModal.executeBtnClassName = 'btn-primary';
        this.smokeAlarmTestModal.executeBtnText = undefined;
        this.smokeAlarmTestModal.title = 'Test Selected Devices';
        this.smokeAlarmTestModal.closeBtnText = 'Cancel';
        this.smokeAlarmTestModal.msg = undefined;
      },
      resetNeverTestedModal () {
        this.neverTestedModal.buildingId = this.buildingId;
        this.neverTestedModal.showModal = false;
        this.neverTestedModal.executeBtnDisabled = false;
        this.neverTestedModal.submitting = false;
        this.neverTestedModal.executeBtnClassName = 'btn-primary';
        this.neverTestedModal.executeBtnText = undefined;
        this.neverTestedModal.title = 'Run quick test?';
        this.neverTestedModal.closeBtnText = 'Cancel';
        this.neverTestedModal.msg = undefined;
      },
      /**
       * Get title for given selected filter by mapping
       * !!!IMPORTANT!!! the code also removes the wrong selected filter, such as: url manipulation
       *
       * @param {Array.<string>} filter
       * @param {nameMapping} mapping
       * @param {string} defaultTest
       * @return {string}
       **/
      getTitle(filter, mapping, defaultTest) {
        let titles = [];
        let newFilter = filter.filter(el => {
          let title = '', found = true;

          if(!el) {
            return true;
          }

          let obj = JSON.parse(el).reduce((accumulator, currentValue, currentIndex, array) => {
            if (accumulator[currentValue]) {
              title = accumulator[currentValue][0];
              accumulator = accumulator[currentValue][1];
            }
            else {
              found = false;
            }
            return accumulator;
          }, Object.assign({}, mapping));

          if(found && title) {
            titles.push(title);
          }

          return found;
        });

        /**
         * reset filter
         */
        if(filter.join(',') !== newFilter.join(',')) {
          filter.splice(0);
          filter.push(...newFilter);
        }

        return titles.length ? titles.join(', ') : defaultTest;
      },
      populateSelectKey(arr) {
        return JSON.stringify(arr);
      },
      /**
       * Toggle checkbox check list for selected value
       *
       * @param {string} selectedKey
       * @param {int} pkIndex
       * @param {flatNameMapping} flatList
       * @param {Array.<string>} selectedList
       * @return {Array.<string>}
       **/
      toggleList (selectedKey, pkIndex, flatList, selectedList) {
        // 1. changes apply to children
        let applyToChildren = (remove, selectedKey, pkIndex, flatList, selectedList) => {
          // 1. find all children with recursive search
          let children = this.tools.getChildList(selectedKey, pkIndex, flatList, true);

          // 1.2. apply changes to children
          for (let i = 0; i < children.length; i++) {
            let keyChain = this.tools.getParentList(children[i], pkIndex, flatList);
            let strKeyChain = this.populateSelectKey(keyChain);
            let index = selectedList.indexOf(strKeyChain);

            // 1.2.2. parent remove means all children remove
            if (remove && index > -1) {
              selectedList.splice(index, 1);
            }
            else if (!remove && index < 0) {
              // 1.2.1. parent add means all children add
              selectedList.push(strKeyChain);
            }
          }
        };

        // 2. find self key
        let keyChain = this.tools.getParentList(selectedKey, pkIndex, flatList);
        let strKeyChain = this.populateSelectKey(keyChain);

        // 3. remove or add
        let remove = selectedList.indexOf(strKeyChain) > -1;

        // 4. apply changes to all children
        applyToChildren(remove, selectedKey, pkIndex, flatList, selectedList);

        // 5. apply to self and parent
        if(remove) {
          // 5.1. apply operation on remove
          // 5.1.1. remove self & remove all parents
          for (let i = keyChain.length; i > 0; i--) {
            let parentKey = this.populateSelectKey(keyChain.slice(0, i));
            let parentIndex = selectedList.indexOf(parentKey);
            if (parentIndex > -1) {
              selectedList.splice(parentIndex, 1);
            }
          }
        } else {
          // 5.2.. apply operation on add
          // 5.2.1. add self
          selectedList.push(strKeyChain);

          // 5.2.2. check all parents add can be apply or not
          for (let i = keyChain.length - 2; i > -1; i--) {
            let parentKey = this.populateSelectKey(keyChain.slice(0, i + 1));
            let parentIndex = selectedList.indexOf(parentKey);
            let pk = keyChain[i];
            let children = this.tools.getChildList(pk, pkIndex, flatList, false);
            let found = true;

            // 5.2.3. check all the children are exist
            for (let j = 0; j < children.length; j++) {
              let childKeyChain = this.tools.getParentList(children[j], pkIndex, flatList);
              let strChildKeyChain = this.populateSelectKey(childKeyChain);

              // 5.2.4. if any children are not exist, parent should not be added
              if (selectedList.indexOf(strChildKeyChain) < 0) {
                found = false;
                break;
              }
            }

            // 5.2.5. if none children are not exist, parent should be added
            if (found && parentIndex < 0) {
              selectedList.push(parentKey);
            }
          }
        }

        selectedList.sort();

        return selectedList;
      },
      updateDevice: function ({id, data}) {
        let deviceIndex = this.devices.findIndex(el => el.id === id);
        Vue.set(this.devices, deviceIndex, Object.assign(this.devices[deviceIndex], data));
      },
      getFittingTypes: function (buildingId) {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${buildingId}/fitting_types`,
          path_template: '/api/user-buildings/{building_id}/fitting_types',
          building_id: buildingId
        }).then(response => {
          if(response.status === 200 && buildingId === this.id) {
            this.fittingTypes = response.data.data;
          }
          return response;
        })
      },
      edit: function (device) {
        this.dataToPassToDeviceEditModal.showModal = true;
        this.dataToPassToDeviceEditModal.deviceId = device.id;
        this.dataToPassToDeviceEditModal.buildingId = this.id;
      },
      removeTimer: function () {
        clearTimeout(this.timerPreloadData);
        clearTimeout(this.timerGetUpdatesWhenTimeIsNotNull);
        this.showBuildingInformation = false;
      },
      pageCallback: function (page) {
      },
      getAllLevels: function (devices) {
        let levels = devices.reduce((resource, el) => {
          return resource.concat([this.tools.convertEmpty(el.level, 'N/A')]);
        }, []);
        this.levels.push(...levels);
        this.levels = [...new Set(this.levels)];
        this.levels.sort((new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})).compare);
      },
      sort: function (s) {
        if (s === this.currentSort.field) {
          this.currentSort.sort = this.currentSort.sort === 'asc' ? 'desc' : 'asc'
        }
        this.currentSort.field = s
      },
      smokeAlarmSort: function (s) {
        if (s === this.currentSmokeAlarmSort.field) {
          this.currentSmokeAlarmSort.sort = this.currentSmokeAlarmSort.sort === 'asc' ? 'desc' : 'asc'
        }
        this.currentSmokeAlarmSort.field = s
      },
      nonEmergencySort: function (s) {
        if (s === this.currentNonEmergencySort.field) {
          this.currentNonEmergencySort.sort = this.currentNonEmergencySort.sort === 'asc' ? 'desc' : 'asc'
        }
        this.currentNonEmergencySort.field = s
      },
      callTest (deviceIds, type) {
        let buildingId = this.id;
        return this.$store.dispatch('apiResult', {
          method: 'POST',
          path: `api/user-buildings/${buildingId}/devices-commands/`,
          path_template: '/api/user-buildings/{building_id}/devices-commands/{device_id}',
          building_id: buildingId,
          data: {deviceIds, type}
        }).then(response => {
          if(response.status === 200 && buildingId === this.id) {
            switch (type) {
              case 'full':
                for (let index in deviceIds) {
                  Vue.set(this.isDisplay, deviceIds[index], true);
                  Vue.set(this.isDisplayTestStatus, deviceIds[index], true);
                  Vue.set(this.showProgressBar, deviceIds[index], false);
                  Vue.set(this.testStatus, deviceIds[index], ['communicating', (new Date()).getTime() / 1000, 'Communicating']);
                  Vue.set(this.testType, deviceIds[index], type);
                  Vue.set(this.deviceSearchInfo, deviceIds[index], this.getSearchStatusInfo(this.deviceStatus[deviceIds[index]], this.testStatus[deviceIds[index]]));
                }
                break;
              case 'quick':
                for (let index in deviceIds) {
                  Vue.set(this.funcIsDisplay, deviceIds[index], true);
                  Vue.set(this.funcIsDisplayTestStatus, deviceIds[index], true);
                  Vue.set(this.funcShowProgressBar, deviceIds[index], false);
                  Vue.set(this.funcTestStatus, deviceIds[index], ['communicating', (new Date()).getTime() / 1000, 'Communicating']);
                  Vue.set(this.testType, deviceIds[index], type);
                }
                break;
            }

            this.$emit('reFetchScheduledTests');
          }
        });
      },
      testSelected () {
        this.callTest(this.checkedValue.selectedValue, this.checkedValue.type).then(response => {
          this.checkedValue.selectedValue = [];
        });
      },
      smokeAlarmTestSelected () {
        this.callTest(this.smokeAlarmCheckedValue.selectedValue, this.smokeAlarmCheckedValue.type).then(response => {
          this.smokeAlarmCheckedValue.selectedValue = [];
        });
      },
      testNeverTested (type) {
        let deviceIds = [];
        for (let i = 0; i < this.neverTestedDevices.length; i++) {
          deviceIds.push(this.neverTestedDevices[i].id);
        }

        this.callTest(deviceIds, type);
      },
      fetchPagedDevices (buildingId, page) {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${buildingId}/devices?page=${page}`,
          path_template: '/api/user-buildings/{building_id}/devices',
          building_id: buildingId
        }).then(response => {
          if(buildingId === this.id) {
            if (response.status === 200) {
              let qty = response.data?.meta?.qty;
              qty = qty ? qty : 0;
              if (qty === 0) {
                this.noDevicesFound = true;
              } else {
                // Transform the data by inserting a fully qualified level and exchanging the model id for a name
                for (let i = 0; i < response.data.data.length; i++) {
                  response.data.data[i].level = [response.data.data[i].sub_building_name, response.data.data[i].level].filter(el => el).join(' - ');
                  response.data.data[i].device_model = this.deviceModels[response.data.data[i].device_model_id];
                }
                // Filter the data by eliminating non-emergency devices
                const emergencyDevices = response.data.data.filter((device) => {
                  const deviceModel = this.deviceModels[device.device_model_id];
                  return !deviceModel || deviceModel.test_type === 2; // This means fully testable, which means it's an emergency light
                });
                const smokeAlarmDevices = response.data.data.filter((device) => {
                  const deviceModel = this.deviceModels[device.device_model_id];
                  return deviceModel && deviceModel.id === 192; // Saturn optical smoke alarm
                });
                const nonEmergencyDevices = response.data.data.filter((device) => {
                  const deviceModel = this.deviceModels[device.device_model_id];
                  return deviceModel && deviceModel.test_type !== 2 && deviceModel.id !== 192; // Any non-emergency device, non-smoke alarm device
                });
                this.devices.push(...emergencyDevices);
                this.smokeAlarmDevices.push(...smokeAlarmDevices);
                this.nonEmergencyDevices.push(...nonEmergencyDevices);

                this.getAllLevels(emergencyDevices);

                this.currentPage++;

                if (!this.totalPage) {
                  this.totalPage = response.data.meta.total;
                }

                this.showBuildingInformation = this.currentPage === this.totalPage;

                if (this.showBuildingInformation) {
                  this.getUpdatesWhenTimeIsNull(buildingId);
                }
              }
            } else if (response.status === 401)  {
              this.showErrorMessage = true;
            }
          }
          return response;
        });
      },
      async fetchDevices (buildingId) {
        this.moreInfo = !this.moreInfo;
        this.devices = [];
        this.currentPage = 0;
        this.totalPage = 0;
        let response = await this.fetchPagedDevices(buildingId, 0);
        if(buildingId === this.id) {
          switch (response.status) {
            case 200 :
              let total = response.data?.meta?.total;
              total = total ? total : 0;
              for (let i = 1; i < total; i++) {
                this.fetchPagedDevices(buildingId, i);
              }
              break;
          }
        }
      },
      confirmCancelTest (device) {
        switch(this.testType[device.id]) {
          case 'quick':
            this.dataToPassToDeviceTestCancelModal.title = 'Cancel quick test?';
            this.dataToPassToDeviceTestCancelModal.executeBtnText = 'Cancel Quick Test';
            break;
          case 'full':
            this.dataToPassToDeviceTestCancelModal.title = 'Cancel full discharge test?';
            this.dataToPassToDeviceTestCancelModal.executeBtnText = 'Cancel Full Discharge Test';
            break;
        }
        this.dataToPassToDeviceTestCancelModal.msg = `This will cancel the currently running test for device ${device.fitting_number}.`;
        this.dataToPassToDeviceTestCancelModal.id = device.id;
        this.dataToPassToDeviceTestCancelModal.showModal = true;
      },
      resetCancelTest () {
        this.dataToPassToDeviceTestCancelModal.title = '';
        this.dataToPassToDeviceTestCancelModal.msg = '';
        this.dataToPassToDeviceTestCancelModal.id = '';
        this.dataToPassToDeviceTestCancelModal.showModal = false;
      },
      cancelTest (deviceId) {
        let data = {
          type: this.testType[deviceId]
        };

        switch(data.type) {
          case 'quick':
            this.funcIsDisplay[deviceId] = false;
            this.funcTestStatus[deviceId] = ['canceled', (new Date()).getTime() / 1000];
            this.funcShowProgressBar[deviceId] = false;
            Vue.set(this.testType, deviceId, undefined);
            break;
          case 'full':
            this.isDisplay[deviceId] = false;
            this.testStatus[deviceId] = ['canceled', (new Date()).getTime() / 1000];
            this.showProgressBar[deviceId] = false;
            this.deviceSearchInfo[deviceId] = this.getSearchStatusInfo(this.deviceStatus[deviceId], this.testStatus[deviceId]);
            break;
        }

        return this.$store.dispatch('apiResult', {
          method: 'POST',
          path: `api/user-buildings/${this.id}/devices-commands/${deviceId}`,
          path_template: '/api/user-buildings/{building_id}/devices-commands/{device_id}',
          building_id: this.id,
          data
        });
      },
      getStatusUpdateRequestConfig(buildingId, query) {
        return {
          section: 'emiot',
          method: 'GET',
          path: `api/user-buildings/${buildingId}/devices-commands?${query.join('&')}`,
        };
      },
      fetchPagedUpdates (buildingId, page, timeFlag) {
        let query = [],
          data = {page, timeFlag};
        for (let i in data) {
          if (data[i] !== undefined) {
            query.push(`${i}=${data[i]}`);
          }
        }
        return this.$store.dispatch('modernApiRequest', this.getStatusUpdateRequestConfig(buildingId, query))
          .then(response => {
            if (response.status === 200 && buildingId === this.id) {
              if (page === 0) {
                this.deviceStatusListFlatRaw = response.data.meta.status_list;
                this.testStatusRawMapping = response.data.meta.test_result_list;
                this.funcTestStatusRawMapping = response.data.meta.func_test_result_list;
              }

              Object.assign(this.deviceUpdates, this.deviceUpdates.concat(response.data.data));

              this.testResultsDisplay(response.data.data, buildingId);

              this.metaUpdate.currentPage++;

              if (!this.metaUpdate.totalPage) {
                this.metaUpdate.totalPage = response.data.meta.total;
              }

              if (this.metaUpdate.currentPage === this.metaUpdate.totalPage) {
                this.serverTimeStamp = response.data.meta.time;
                this.canAcceptTest = response.data.meta.canTest;
                this.getUpdatesWhenTimeIsNotNull(true, buildingId);
              }
            }

            return response;
          });
      },
      async getUpdatesWhenTimeIsNull (buildingId) {
        this.deviceUpdates = [];
        this.metaUpdate.totalPage = 0;
        this.metaUpdate.currentPage = 0;
        this.testResults = {};
        this.deviceStatus = {};

        this.testStatus = {};
        this.isDisplay = {};
        this.isDisplayTestStatus = {};
        this.timeWaiting = {};
        this.timeDifference = {};
        this.testPercentage = {};
        this.showProgressBar = {};

        this.funcTestStatus = {};
        this.funcIsDisplay = {};
        this.funcIsDisplayTestStatus = {};
        this.funcTimeWaiting = {};
        this.funcTimeDifference = {};
        this.funcTestPercentage = {};
        this.funcShowProgressBar = {};

        this.testType = {};

        let response = await this.fetchPagedUpdates(buildingId, 0, undefined);
        if (!this.destroyed) {
          switch (response.status) {
            case 200 :
              let total = response.data?.meta?.total;
              total = total ? total : 0;
              for (let i = 1; i < total; i++) {
                this.fetchPagedUpdates(buildingId, i, response.data.meta.current_time);
              }
              break;
          }
        }
      },
      async getUpdatesWhenTimeIsNotNull (init = false, buildingId) {
        if (this.destroyed) {
          return;
        }
        let top = this;
        if (init === false) {

          let response = await this.$store.dispatch(
              'modernApiRequest',
              this.getStatusUpdateRequestConfig(buildingId, [`timeNumber=${this.serverTimeStamp}`]),
          );

          if(buildingId === this.id) {
            switch (response.status) {
              case 200:
                this.applyServerTime(response.data.meta.time);
                this.canAcceptTest = response.data.meta.canTest;
                for (let index in response.data.data) {
                  this.deviceUpdates.splice(this.deviceUpdates.findIndex(device => device.id == response.data.data[index].id), 1, response.data.data[index]);
                }
                this.testResultsDisplay(response.data.data, buildingId);

                let statusListInfo = {
                    'status_error': 0,
                    'status_warning': 0,
                    'status_ok': 0,
                  },
                  statusListInfoKeys = Object.keys(statusListInfo),
                  deviceIdList = Object.keys(this.deviceStatus),
                  building = this.$store.getters.building({buildingId});

                let deviceIdToIsEmergency = {};
                for (let device of this.devices) {
                  const deviceModel = this.deviceModels[device.device_model_id];
                  const isEmergency = !deviceModel || deviceModel.test_type === 2;
                  deviceIdToIsEmergency[device.id] = isEmergency;
                }
                for (let i = 0; i < statusListInfoKeys.length; i++) {
                  let statusInfoKey = statusListInfoKeys[i];
                  for (let j = 0; j < deviceIdList.length; j++) {
                    let singleDeviceStatus = this.deviceStatus[deviceIdList[j]];
                    const isEmergency = deviceIdToIsEmergency[deviceIdList[j]];
                    if(isEmergency && singleDeviceStatus.some(statusInfo => this.deviceStatusListFlat[statusInfo['status']][2].indexOf(statusInfoKey) > -1)) {
                      statusListInfo[statusInfoKey]++;
                    }
                  }
                  if(building[statusInfoKey] !== statusListInfo[statusInfoKey]) {
                    building[statusInfoKey] = statusListInfo[statusInfoKey];
                  }
                }

                break;
              case 422:
                let timeStampMatch = JSON.stringify(response.data.timeNumber).match(/\[(\d+)\]/);
                if (timeStampMatch) {
                  this.applyServerTime(timeStampMatch[1]);
                }
                break;
            }
          }
        }

        let timeGaps = this.serverTimeStamp * 10000 - (new Date()).getTime() + 5000;

        // at least 1 second in gap
        timeGaps = timeGaps > 1000 ? timeGaps : 1000;

        this.timerGetUpdatesWhenTimeIsNotNull = setTimeout(
          function() {
            // always clear timer, to avoid possible racing
            clearTimeout(top.timerGetUpdatesWhenTimeIsNotNull);
            top.getUpdatesWhenTimeIsNotNull(false, buildingId);
          },
          timeGaps
        );
      },
      testResultsDisplay (data, buildingId) {
        for (let index in data) {
          let updateMeta = this.deviceUpdates.find(device => device.id == data[index].id),
            deviceId = updateMeta.id,
            deviceStatus = this.getDeviceStatus(updateMeta);
          let {testStatus, isDisplay} = this.getTestStatus(updateMeta),
            {testStatus: funcTestStatus, isDisplay: funcIsDisplay} = this.getFuncTestStatus(updateMeta),
            {testType} = this.getTestType(updateMeta),
            getSearchInfo = this.getSearchStatusInfo(deviceStatus, testStatus);

          Vue.set(this.deviceStatus, deviceId, deviceStatus);

          Vue.set(this.testStatus, deviceId, testStatus);
          Vue.set(this.isDisplay, deviceId, isDisplay);
          Vue.set(this.isDisplayTestStatus, deviceId, testStatus !== undefined);

          Vue.set(this.funcTestStatus, deviceId, funcTestStatus);
          Vue.set(this.funcIsDisplay, deviceId, funcIsDisplay);
          Vue.set(this.funcIsDisplayTestStatus, deviceId, funcTestStatus !== undefined);

          Vue.set(this.testType, deviceId, testType);

          Vue.set(this.deviceSearchInfo, deviceId, getSearchInfo);
        }

        this.repopulateTime(this.isDisplay, this.testStatus, this.totalTestTime, {
          timeDifference: 'timeDifference',
          testPercentage: 'testPercentage',
          showProgressBar: 'showProgressBar',
          timeWaiting: 'timeWaiting',
        });

        this.repopulateTime(this.funcIsDisplay, this.funcTestStatus, this.totalFuncTestTime, {
          timeDifference: 'funcTimeDifference',
          testPercentage: 'funcTestPercentage',
          showProgressBar: 'funcShowProgressBar',
          timeWaiting: 'funcTimeWaiting',
        });
      },
      myStyles: function (percentage) {
        return {
          width: `${percentage}%`
        }
      },
      getLocations: function (buildingId) {
        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${this.id}/locations`,
          path_template: '/api/user-buildings/{building_id}/locations',
          building_id: this.id
        }).then(response => {
          if(response.status === 200 && buildingId === this.id) {
            this.locations = response.data.data;
          }
        });
      },
      getPercentage: function (totalTestTime, timeDifference) {
        let timeLeft = totalTestTime - timeDifference;

        if(timeLeft < 0) {
          return `Testing`
        } else {
          let secondsLeft = Math.round(timeLeft / 1000);
          let minutesLeft = Math.round(secondsLeft / 60);

          if(minutesLeft < 1) {
            return `${secondsLeft} second${secondsLeft !== 1 ? 's' : ''} left`;
          }

          return `${minutesLeft} minute${minutesLeft !== 1 ? 's' : ''} left`;
        }
      },

      downloadCSV: function () {
        let columns = ['NO', 'TYPE', 'LEVEL', 'LOCATION DESCRIPTION', 'MODEL', 'WARRANTY EXPIRY'],
          data = [],
          filename = 'device-list.csv';

        for (let i in this.devices) {
          let activationDateSeconds = this.devices[i].activation_date;
          let warrantyExpiry = null;
          if (activationDateSeconds) {
            let activationDate = new Date(activationDateSeconds * 1000)
            activationDate.setDate((activationDate.getDate() + this.devices[i].warranty))

            warrantyExpiry = this.tools.formatDateWithFullYear(new Date(activationDate))
          }
          let device = {
            'NO': this.devices[i].fitting_number,
            'TYPE': this.devices[i].fitting_type == null ? '' : this.devices[i].fitting_type.name,
            'LEVEL': this.devices[i].level,
            'LOCATION DESCRIPTION': this.devices[i].location,
            'MODEL': this.devices[i].device_model == null ? '' : this.devices[i].device_model.name,
            'WARRANTY EXPIRY': warrantyExpiry
          };
          data.push(device);
        }

        this.tools.downloadCSV(data, columns, filename);
      },
      /**
       * Populate device status list from given device meta data
       *
       * @param {updateMeta} updateMeta the meta data feed by API endpoint
       * @return {Array.<DeviceStatus>}
       */
      getDeviceStatus: function(updateMeta) {
        return updateMeta.device_status.map(el => {
          if(['status_ok', 'network_error'].indexOf(el.status) > -1) {
            el['title'] =  `Last communication <br>${this.tools.formatDateTimeWithOutSeconds(new Date(el.timestamp * 1000))}`;
          }
          else if(el.status === 'not_tested') {
            el['title'] =  'Not tested in the latest scheduled test';
          }
          return el;
        });
      },
      /**
       * Populate Test Status for each device for display text and desc; also possible test duration calculation; whether
       * display test duration bar or not
       *
       * @param {updateMeta} updateMeta the meta data feed by API endpoint
       * @return {{testStatus: DeviceTestStatus, isDisplay: boolean}}
       */
      getTestStatus: function (updateMeta) {
        let testStatus, timeDifference, testPercentage, isDisplay = false;
        if (updateMeta.test_result != null) {
          testStatus = [
            updateMeta.test_result['status'],
            updateMeta.test_result['timestamp'],
            undefined,
          ];

          if (['communicating', 'delayed', 'testing'].indexOf(updateMeta.test_result['status']) > -1) {
            isDisplay = true;
          }

          if (updateMeta.test_result['status'] === 'passed') {
            testStatus[2] = 'The device successfully passed a full discharge test.';
          }
        }

        return {testStatus, isDisplay};
      },
      getFuncTestStatus: function (updateMeta) {
        let testStatus, timeDifference, testPercentage, isDisplay = false;
        if (updateMeta.func_test_result != null) {
          isDisplay = ['communicating', 'waiting', 'testing'].indexOf(updateMeta.func_test_result['status']) > -1;

          testStatus = [
            updateMeta.func_test_result['status'],
            updateMeta.func_test_result['timestamp'],
            undefined,
          ];
        }

        return {testStatus, isDisplay};
      },
      getTime: function(testStatus, totalTime) {
        let timeWaiting,
          timeDifference,
          testPercentage,
          currentDate = new Date(),
          serverDate = new Date(testStatus[1] * 1000);

        if (testStatus[0] === 'testing') {
          let finishDateTime = new Date(serverDate.getTime() + totalTime);
          timeDifference = currentDate.getTime() - serverDate.getTime();
          testPercentage = timeDifference < totalTime ? Math.floor(timeDifference * 100 / totalTime) : 100;
          testStatus[2] = `Test will be finished before ${finishDateTime.toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'})}`;
        }
        else if (['communicating', 'delayed', 'waiting'].indexOf(testStatus[0]) > -1) {
          timeWaiting = currentDate.getTime() - serverDate.getTime();
        }

        return {timeWaiting, timeDifference, testPercentage};
      },
      getTestType: function (updateMeta) {
        let testType;
        if (updateMeta.test_result != null && ['communicating', 'delayed', 'testing'].indexOf(updateMeta.test_result['status']) > -1) {
          testType = 'full';
        } else if (updateMeta.func_test_result != null && ['communicating', 'waiting', 'testing'].indexOf(updateMeta.func_test_result['status']) > -1) {
          testType = 'quick';
        }

        return {testType};
      },
      /**
       * Populate array of string for further text search
       *
       * @param {Array.<DeviceStatus>} deviceStatus
       * @param {DeviceTestStatus} testStatus
       * @return {Array}
       */
      getSearchStatusInfo: function(deviceStatus, testStatus) {
        let info = [];
        // device status
        if (deviceStatus !== undefined && deviceStatus.length) {
          for (let i = 0; i < deviceStatus.length; i++) {
            let index = deviceStatus[i]['status'];
            info.push(`STATUS ${this.deviceStatusListFlat[index][0]}`);
          }
        }
        // device test
        if (testStatus !== undefined && testStatus.length && testStatus[0] !== undefined && Object.keys(this.testStatusList).length) {
          info.push(`LAST TEST RESULT ${this.testStatusList[testStatus[0]][0]}`);
        }

        // device test time
        if (testStatus !== undefined && testStatus.length && testStatus[1] !== undefined) {
          info.push(`LAST TEST DATE ${testStatus[1] * 1000 < 1262304001000 ? 'Unknown' : this.tools.humanizedTimeSpan(new Date(testStatus[1] * 1000))}`);
          info.push(`LAST TEST DATE ${testStatus[1] * 1000 < 1262304001000 ? 'Unknown' : this.tools.formatDateTimeWithOutSeconds(new Date(testStatus[1] * 1000))}`);
        }

        return info;
      },

      repopulateTime: function(isDisplayList, testStatusList, totalTime, nameMapping) {
        for (const [deviceId, isDisplay] of Object.entries(isDisplayList)) {
          if (isDisplay) {
            let {timeWaiting, timeDifference, testPercentage} = this.getTime(testStatusList[deviceId], totalTime);

            Vue.set(this[nameMapping.timeWaiting], deviceId, timeWaiting);
            Vue.set(this[nameMapping.timeDifference], deviceId, timeDifference);
            Vue.set(this[nameMapping.testPercentage], deviceId, testPercentage);
            Vue.set(this[nameMapping.showProgressBar], deviceId, testPercentage !== undefined);
          }
        }
      }
    },
  }
</script>